/* eslint-disable camelcase */
// export const server_url = 'http://10.97.28.83:8002/'
// export const ws_server_url = 'ws://10.97.28.83:8002/'
export const server_url = 'https://shopping-cart-api.up.railway.app/'
export const ws_server_url = 'wss://shopping-cart-api.up.railway.app/'
export const cloudinary_upload_url =
  'https://api.cloudinary.com/v1_1/ecommero/image/upload'
export const cloudinary_sub_categories = 'd11htdsp'
export const cloudinary_products = 'cb9rpz8r'
